// Mock API mode, toggled via the Konami code (see hooks/konami.ts). When
// enabled, API helpers hit the backend's mock endpoints instead of the
// real ones so the UI can be developed and demoed without live data.

const MOCK_KEY = "mock-api";

export const isMockEnabled = (): boolean =>
  localStorage.getItem(MOCK_KEY) === "true";

export const setMockEnabled = (enabled: boolean): void => {
  if (enabled) {
    localStorage.setItem(MOCK_KEY, "true");
  } else {
    localStorage.removeItem(MOCK_KEY);
  }
};

// The account the mock campaign endpoints answer for. The customer list
// is shared with the conversion events flow and has no mock behind it, so
// anything that would look an account up stands these in instead.
export const MOCK_GOOGLE_ADS_ACCOUNT = "1234567890";
export const MOCK_GOOGLE_ADS_ACCOUNT_NAME = "Mock Ads Account";
